import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "../Components/Spinner";
import { TooltipIcon } from "../Components/Tooltips/TooltipInfos";

const GoogleMapComponent = React.lazy(() =>
  import("../Components/Maps/GoogleMapComponent")
);
const GoogleMapTrackComponent = React.lazy(() =>
  import("../Components/Maps/GoogleMapTrackComponent")
);
const PaginatedTableFleet = React.lazy(() =>
  import("../Components/Tables/Customs/PaginatedTableFleet")
);

// Visão alternativa da tela "Minha Frota" (issue #557), ligada pelo switch
// "Visão expandida" no GlobalHeader (FleetViewContext) — mapa maior seguido
// do grid completo, sem paginação, em vez do accordion padrão de Fleet.jsx.
//
// Não busca nada por conta própria: recebe os MESMOS dados e callbacks que
// Fleet.jsx já usa pro item "gridAndMap" do accordion (mesma state,
// mesmo polling de 10s) — trocar entre as duas visões não refaz fetch nem
// interrompe o refresh automático.
//
// isGridVisible=false força GoogleMapComponent a usar a variante de altura
// maior — não existe accordion aqui, então essas props só controlam o
// tamanho do mapa, não visibilidade de verdade. mapHeight sobrepõe pra um
// mapa ainda maior que o do accordion.
//
// Títulos "Mapa" e "Painel Geral (Grid)" usam o mesmo estilo visual do
// accordion (title-info + TooltipIcon), mas são estáticos — sem
// comportamento de expandir/colapsar.
const MAP_HEIGHT = "85vh";

export default function FleetExpandedView({
  mapLoading,
  locationsTrackingList,
  createMap,
  handleOnlyPositionEvents,
  handleClick,
  selectedIndex,
  onHandled,
  handlePositionTrack,
  chooseDisplay,
  showTrackEvents,
  vehicleToTrack,
  vehicleSelected,
  dataLoading,
  paginatedTrackingList,
  reloadGrid,
  triggerClick,
  openCommandModal,
  handleSelectedVehicle,
  handleTwoClick,
}) {
  const { t } = useTranslation();

  return (
    <div className="card-grid-component">
      <div className="d-flex justify-content-between w-100">
        <span className="title-info">
          {t("TITLE.MAP")}
          <TooltipIcon tooltipKey={t("MINHA_FROTA")} placement="bottom" />
        </span>
      </div>

      <Suspense fallback={<Spinner />}>
        {!showTrackEvents ? (
          <GoogleMapComponent
            id="googleMapComponentExpanded"
            mapLoading={mapLoading}
            locations={locationsTrackingList}
            createMap={createMap}
            handleOnlyPositionEvents={handleOnlyPositionEvents}
            handleClick={handleClick}
            selectedIndex={selectedIndex}
            onHandled={onHandled}
            activeTab="gridAndMap"
            isMapVisible
            isGridVisible={false}
            mapHeight={MAP_HEIGHT}
            handlePositionTrack={handlePositionTrack}
            chooseDisplay={chooseDisplay}
          />
        ) : (
          <GoogleMapTrackComponent
            activeTab="gridAndMap"
            mapLoading={mapLoading}
            chooseDisplay={chooseDisplay}
            vehicle={vehicleToTrack}
          />
        )}
      </Suspense>

      {/* Espaço maior entre o mapa e o grid — a rolagem pra chegar no grid
          é esperada aqui (mapa grande + grid completo sem paginação). */}
      <div className="grid-component p-1" style={{ marginTop: "3rem" }}>
        <div className="d-flex justify-content-between w-100">
          <span className="title-info">
            {t("TITLE.MAIN_GRID")}
            <TooltipIcon tooltipKey={t("MINHA_FROTA")} placement="bottom" />
          </span>
        </div>

        <Suspense fallback={<Spinner />}>
          <PaginatedTableFleet
            id="PaginatedTableFleetExpanded"
            activeTab="gridAndMap"
            selectedVehicle={vehicleSelected}
            dataLoading={dataLoading}
            data={paginatedTrackingList.vehiclesUser}
            totalRecords={undefined}
            onPageChange={undefined}
            disablePaging
            handleSelectedVehicle={handleSelectedVehicle}
            handleTwoClick={handleTwoClick}
            isGridVisible
            isMapVisible
            reloadGrid={reloadGrid}
            chooseDisplay={chooseDisplay}
            triggerClick={triggerClick}
            openCommandModal={openCommandModal}
            columns={[
              "Placa",
              "Grupo",
              "Data/Hora",
              "ST",
              "IG",
              "V",
              "M",
              "Localização",
            ]}
            fields={[
              "plate",
              "vehicleGroupName",
              "generatedAt",
              "colorFilter",
              "ignition",
              "speedStatusFilter",
              "userDriverName",
              "location",
            ]}
          />
        </Suspense>
      </div>
    </div>
  );
}
